import { gql } from "graphql-request";
import graphQLClient from 'config/graphql-instance';
import { Estates } from "types/order";
import { AccountingFilter, AccountingType } from "v2-types/order";

export type GQLEarnestCommissions = {
  getOrder: {
    accounting:AccountingType[]
  } & Estates
};

export const getEarnestComissionsData = async (
  payload: {
    id: string,
    filters?: {[key: string]: AccountingFilter}
  }
) => {
  const query = gql`
    query GetOrder($id: ID!, $filters: OrderFilters) {
      getOrder(_id: $id, filters: $filters) {
        estates {
          _id
          address {
            _id
            address
          }
          accounting {
            _id
            code
            amount
            involved_parties {
              _id
              amount
              kind
              name
              order_kinds
              percent
            }
          }
        }
        accounting {
          _id
          amount
          amount_override
          code
          description
          kind
        }
        parties {
          _id
        }
      }
    }
  `;
  const response = await graphQLClient()
    .request<GQLEarnestCommissions>(query, payload);

  return response;
};